import React, { useState, useEffect } from "react";
import {
  Wrapper,
  Content,
  Identity,
  Monogram,
  Nameplate,
  Name,
  Role,
  NavLinkBox,
  NavLink,
  Availability,
  AvailabilitySignal,
} from "./Nav.styles";
import Container from "../Container";
import { useSectionNavigation } from "../../hooks/useScrollAnimation";

const sections = ["home", "about", "work", "contact"];

const links = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "work", label: "Work" },
  { id: "contact", label: "Contact" },
];

const Nav = () => {
  // Use section navigation for better detection
  const { activeSection } = useSectionNavigation(sections);

  const [scrolled, setScrolled] = useState(false);

  // Give the nav a backdrop once the page has moved off the top
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 8);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Initial call

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Wrapper $scrolled={scrolled}>
      <Container>
        <Content>
          <Identity href="/#home">
            <Monogram>JS</Monogram>
            <Nameplate>
              <Name>James Spears</Name>
              <Role>Software engineer</Role>
            </Nameplate>
          </Identity>
          <NavLinkBox>
            {links.map((link) => {
              return (
                <NavLink
                  key={link.id}
                  href={`/#${link.id}`}
                  $active={(activeSection || "home") === link.id}
                >
                  {link.label}
                </NavLink>
              );
            })}
          </NavLinkBox>
          <Availability>
            <AvailabilitySignal />
            Based in Seattle, WA
          </Availability>
        </Content>
      </Container>
    </Wrapper>
  );
};

export default Nav;
